// extracted by mini-css-extract-plugin
module.exports = {"condition":"style__condition__p8eiB"};